import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ArrowLeftIcon = (p: IconProps) => <Icon {...p}><path d="M19 12H5" /><path d="M12 19l-7-7 7-7" /></Icon>
